import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';

@Component({
    selector: 'app-add-hutang-request',
    templateUrl: './add-hutang-request.component.html',
    styleUrls: ['./add-hutang-request.component.scss'],
    standalone: false
})
export class AddHutangRequestComponent {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);


  disabledSubmit = false;
  selectedCustomer: Customer;
  selectedProfile: Profile;
  loanAmount: number;
  remark: string;

  updateSalaryDetailsAndTaskDate() { }

  openUploadApplicationFormModal() { }

  submit() {
    if (this.loanAmount == undefined || this.loanAmount == 0)
      this.sharedService.openAlert("Please fill in HUTANG AMOUNT", ALERT_TYPE.DANGER)
    else if (this.remark == "" || this.remark == undefined)
      this.sharedService.openAlert("Please fill in HUTANG REASON", ALERT_TYPE.DANGER)
    else {
      this.addHutangLoanRequest();
    }
  }

  addHutangLoanRequest() {
    const loanData = {
      "principal": this.loanAmount,
      "scheme": "HUTANG",
      "term": 1
    }

    const data = {
      "profileId": this.selectedProfile.ID,
      "loanInfo": loanData,
      "remark": this.remark,
      "requestOn": new Date().toISOString(),
    }

    const xhr = this.restApi.postRequest(this.constructApi.getAddLoanRequest(), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        //if success , then proceed
        if (xhr.status == 200) {
          window.location.reload();
        } else {
          this.disabledSubmit = false;
          //show error message
          this.sharedService.openAlert(JSON.parse(xhr.responseText).error, ALERT_TYPE.DANGER)
        }
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
